import {
  LOGIN_SUCCESS,
  LOGIN_START,
  LOGIN_ERROR,
  REGISTER_ERROR,
  REGISTER_START,
  REGISTER_SUCCESS,
  AIRBNB_LOGIN_START,
  AIRBNB_CAPTCHA_VERIFICATION_REQUESTED,
  AIRBNB_CAPTCHA_VERIFICATION_WAITING,
  AIRBNB_CAPTCHA_VERIFICATION_SUCCESS,
  AIRBNB_EMAIL_VERIFICAION_START,
  AIRBNB_EMAIL_VERIFICAION_SUCCESS,
  AIRBNB_LOGIN_SUCCESS,
  AIRBNB_LOGIN_ERROR,
  AuthSuccessState,
  SET_USER_INFO_RATE_LIMITED,
} from './types';
import { AppDispatch } from '../../core/StoreProvier/StoreProvider';
import { AuthErrorState } from './types';
import { AirbnbAuthPayload } from 'src/interfaces/iuser';
import { processAirbnbAuthResponse } from 'src/utils/functions';

export const loginStart = (payload: AuthSuccessState) => ({
  type: LOGIN_START,
  payload,
});

export const loginSuccess = (payload: AuthSuccessState) => ({
  type: LOGIN_SUCCESS,
  payload,
});

export const loginError = (payload: AuthSuccessState) => ({
  type: LOGIN_ERROR,
  payload,
});

export const registerStart = (payload: AuthSuccessState) => ({
  type: REGISTER_START,
  payload,
});

export const registerSuccess = (payload: AuthSuccessState) => ({
  type: REGISTER_SUCCESS,
  payload,
});

export const registerError = (payload: AuthErrorState) => ({
  type: REGISTER_ERROR,
  payload,
});

export const setUserInfoRateLimited = (payload: boolean) => ({
  type: SET_USER_INFO_RATE_LIMITED,
  payload,
});

export const getTokenThunk = () => () => localStorage.getItem('auth-token');

export const loginThunk = ({ email, password }) => async (dispatch: AppDispatch, _, api) => {
  dispatch(loginStart({ error: false }));
  dispatch(setUserInfoRateLimited(false));

  try {
    const response = await api(
      'https://qlekbww2f4.execute-api.us-east-2.amazonaws.com/login', 
      {
        body: [{ email, password }],
        method: 'post',
        queryParams: {
          apiType: 'v2',
        },
      }, 
      false, 
      false, 
      '', 
      'POST', 
      true, 
      undefined, 
      true, 
      true
    );

    console.log('RESPONSE: ', response);

    if (response && response.status === 429) {
      dispatch(setUserInfoRateLimited(true));
      dispatch(loginSuccess({ error: false }));
      return;
    }

    if (
      response &&
      typeof response.message === 'string' &&
      response.message !== 'Internal Server Error' &&
      response.message !== 'Failed to fetch'
    ) {
      localStorage.setItem('auth-token', response.message);
      dispatch(loginSuccess({ error: false }));
    } else {
      dispatch(loginError({ error: true })); //TODO: Show a message
    }
  } catch (error) {
    console.error('Failed to login:', error);
    dispatch(loginError({ error: true }));
  }
};

export const registerThunk = ({
  email,
  password,
  name,
  userDescription,
  userSubDescription,
  lang,
  page,
  type,
  region,
  landing,
  device,
  signupCountryCode,
  tailoredRegion,
  affiliateKey,
  noOfUserSearch,
}) => async (dispatch: AppDispatch, _, api) => {
  dispatch(registerStart({ error: false }));
  dispatch(setUserInfoRateLimited(false));
  
  const response = await api(
    'https://2mamz4uq7g.execute-api.us-east-2.amazonaws.com/default/register',
    {
      body: [
        {
          email,
          password,
          name,
          userDescription,
          userSubDescription,
          lang,
          page,
          type,
          region,
          landing,
          device,
          signupCountryCode,
          tailoredRegion,
          affiliateKey,
          noOfUserSearch,
        },
      ],
      method: 'post',
      queryParams: {
        apiType: 'v2',
      },
    },
    false,
    false,
    '',
    'POST',
    true,
    undefined,
    true,
    true
  );
  console.log('RESPONSE: ', response);

  if (response && response.status === 429) {
    dispatch(setUserInfoRateLimited(true));
    dispatch(registerSuccess({ error: false }));
    return;
  }

  if (response && response.jwt) {
    localStorage.setItem('auth-token', response.jwt.slice(2, -1));
    dispatch(registerSuccess({ error: false }));
    return true;
  } else {
    if (response && response.reason === 'User already exists') {
      dispatch(registerError({ error: true, reason: 'User already exists' }));
    } else if (response && response.reason === 'User account is already deleted') {
      dispatch(registerError({ error: true, reason: 'User account is already deleted' }));
    } else {
      dispatch(registerError({ error: true, reason: 'Internal Server Error' }));
    }

    return false;
  }
};

export const googleAuthRegisterThunk = ({
  clientId,
  lang,
  page,
  type,
  region,
  landing,
  device,
  signupCountryCode,
  tailoredRegion,
  affiliateKey,
  noOfUserSearch,
}) => async (dispatch: AppDispatch, _, api) => {
  dispatch(registerStart({ error: false }));
  try {
    const response = await api(
      ' https://m851w3vxv4.execute-api.us-east-2.amazonaws.com/default/googleAuth',
      {
        body: [
          {
            credential: clientId,
            lang,
            page,
            type,
            region,
            landing,
            device,
            signupCountryCode,
            tailoredRegion,
            affiliateKey,
            noOfUserSearch,
          },
        ],
        method: 'post',
      }
    );

    if (response && response.jwt && response.jwt !== 'Failed to fetch') {
      localStorage.setItem('auth-token', response.jwt.slice(2, -1));
      dispatch(registerSuccess({ error: false }));
      return { ok: true as const, isNewGoogleSignup: Boolean(response.new_google_signup) };
    } else {
      dispatch(registerError({ error: true, reason: 'Internal Server Error' }));
      return { ok: false as const };
    }
  } catch (error) {
    console.error('Failed to googleAuth:', error);
    dispatch(registerError({ error: true, reason: 'Internal Server Error' }));
    return { ok: false as const };
  }
};

export const logoutThunk = () => () => {
  localStorage.removeItem('auth-token');
  localStorage.removeItem('user-name');
  localStorage.removeItem('user-email');
};

// Airbnb Auth
const airbnbLoginStart = () => ({
  type: AIRBNB_LOGIN_START,
});

const airbnbCaptchaVerificationRequested = (payload: AirbnbAuthPayload) => ({
  type: AIRBNB_CAPTCHA_VERIFICATION_REQUESTED,
  payload,
});

const airbnbCaptchaVerificationWaiting = () => ({
  type: AIRBNB_CAPTCHA_VERIFICATION_WAITING,
});

const airbnbCaptchaVerificationSuccess = (payload: AirbnbAuthPayload) => ({
  type: AIRBNB_CAPTCHA_VERIFICATION_SUCCESS,
  payload,
});

const airbnbEmailVerificationStart = () => ({
  type: AIRBNB_EMAIL_VERIFICAION_START,
});

const airbnbEmailVerificationSuccess = (payload: AirbnbAuthPayload) => ({
  type: AIRBNB_EMAIL_VERIFICAION_SUCCESS,
  payload,
});

const airbnbLoginSuccess = (payload: AirbnbAuthPayload) => ({
  type: AIRBNB_LOGIN_SUCCESS,
  payload,
});

const airbnbLoginError = (payload: AirbnbAuthPayload) => ({
  type: AIRBNB_LOGIN_ERROR,
  payload,
});

export const authenticateAirbnb = (airbnbEmail, airbnbPassword, verificationCode) => async (
  dispatch: AppDispatch,
  getState,
  api
) => {
  const {
    airbnbAuth: { action, airlock_id, user_id },
  } = getState();
  const airbnbAuthURL = 'https://q82j00jymi.execute-api.us-east-2.amazonaws.com/default/airbnbAuth';
  if (action === '') {
    dispatch(airbnbLoginStart());
    const response = await api(
      airbnbAuthURL,
      {
        body: { email: airbnbEmail, password: airbnbPassword },
        method: 'post',
      },
      true
    );
    if (response) {
      switch (response.action) {
        default:
          return;
        case 'captcha':
          dispatch(airbnbCaptchaVerificationRequested(processAirbnbAuthResponse(response)));
          break;
        case 'email_verify':
          dispatch(airbnbCaptchaVerificationSuccess(processAirbnbAuthResponse(response)));
          break;
        case 'wrong_credentials':
          dispatch(airbnbLoginError(processAirbnbAuthResponse(response)));
          break;
        case 'support':
          dispatch(airbnbLoginError(processAirbnbAuthResponse(response)));
          break;
        case 'complete':
          dispatch(airbnbLoginSuccess(processAirbnbAuthResponse(response)));
          break;
      }
      return;
    }
    dispatch(airbnbLoginError(processAirbnbAuthResponse({ action: 'failed' })));
  }

  if (action === 'captcha') {
    dispatch(airbnbCaptchaVerificationWaiting());
    const response = await api(
      airbnbAuthURL,
      {
        body: {
          email: airbnbEmail,
          password: airbnbPassword,
          airlock_id: airlock_id,
          user_id: user_id,
        },
        method: 'post',
      },
      true
    );
    if (response) {
      switch (response.action) {
        default:
          return;
        case 'email_verify':
          dispatch(airbnbCaptchaVerificationSuccess(processAirbnbAuthResponse(response)));
          break;
        case 'wrong_credentials':
          dispatch(airbnbLoginError(processAirbnbAuthResponse(response)));
          break;
        case 'support':
          dispatch(airbnbLoginError(processAirbnbAuthResponse(response)));
          break;
        case 'captcha':
          dispatch(airbnbCaptchaVerificationSuccess(processAirbnbAuthResponse(response)));
          break;
        case 'complete':
          dispatch(airbnbLoginSuccess(processAirbnbAuthResponse(response)));
          break;
      }
      return;
    }
    dispatch(airbnbLoginError(processAirbnbAuthResponse({ action: 'failed' })));
  }

  if (action === 'email_verify') {
    dispatch(airbnbEmailVerificationStart());
    const response = await api(
      airbnbAuthURL,
      {
        body: {
          email: airbnbEmail,
          password: airbnbPassword,
          airlock_id: airlock_id,
          user_id: user_id,
          verification_code: verificationCode,
          verify_email: true,
        },
        method: 'post',
      },
      true
    );
    if (response) {
      switch (response.action) {
        default:
          return;
        case 'wrong_code':
          dispatch(airbnbLoginError(processAirbnbAuthResponse(response)));
          break;
        case 'wrong_credentials':
          dispatch(airbnbLoginError(processAirbnbAuthResponse(response)));
          break;
        case 'email_verify':
          dispatch(airbnbCaptchaVerificationSuccess(processAirbnbAuthResponse(response)));
          break;
        case 'complete':
          dispatch(airbnbLoginSuccess(processAirbnbAuthResponse(response)));
          break;
      }
      return;
    }
    dispatch(airbnbLoginError(processAirbnbAuthResponse({ action: 'failed' })));
  }
};
